module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_Wood.4f37afac.jpg";